import React from 'react';
import { Spin, Empty, Button, Alert } from 'antd';
import { withRouter } from 'react-router-dom';
import AcordoView from './AcordoView';
import { useFetchAcordos } from './use-fetch-acordos';
import './styles.css';

const Acordos = ({ pasta, history }) => {
  const { acordos, loading, error, refetch } = useFetchAcordos(pasta && pasta.pasta);

  if (loading) {
    return (
      <div className="acordos__loading">
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Erro ao carregar acordos"
        description={error}
        type="error"
        showIcon
        className="acordos__error"
        action={
          <Button size="small" onClick={refetch}>
            Tentar novamente
          </Button>
        }
      />
    );
  }

  if (!acordos || acordos.length === 0) {
    return (
      <Empty
        description="Nenhum acordo cadastrado"
        className="acordos__empty"
      >
        <Button
          type="primary"
          onClick={() => history.push(`/acordo/create/${pasta.pasta}`)}
        >
          Cadastrar Acordo
        </Button>
      </Empty>
    );
  }

  return (
    <div className="acordos__container">
      {acordos.map(acordo => (
        <AcordoView
          key={acordo.id}
          acordo={acordo}
          onUpdate={refetch}
        />
      ))}
    </div>
  );
};

export default withRouter(Acordos);



// WEBPACK FOOTER //
// ./src/pages/Pasta/Acordos/index.jsx